import React from "react"


const TextInput = (props) => {
    const {input: {value, onChange, name, onBlur}, meta: {touched, error }} = props;

    return <div className="widget-form__group">

        <div className="input-wrap" id={props.id+"-message"}>
            <label htmlFor={name}>{props.title}</label>
            <input
                autoComplete={props.autocomplete}
                type='text'
                value={value}
                onChange={onChange}
                name={name}
                id={name}
                onBlur={onBlur}
                className={ ( touched && error ) ? "forms__text-input  qfa1-input--validation-error" : "forms__text-input" }
                placeholder={props.placeholder}
            />
            {touched && (error && <div className="validation-error" >{error.message}</div>) }
            {props.children}
        </div>
    </div>
};


export default TextInput